export default __webpack_public_path__ + "static/media/15.fa87f063.jpeg";